import React from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {IconButton, ListItemText} from "@mui/material";
import {InstrumentShortVersion} from "../../gen/api";

type Props = {
  instrument: InstrumentShortVersion
}

function PreviousVersionLink({instrument}: Props) {
  return (
      <>
        <a href={`/show/${instrument.id}` } target="_blank" rel="noopener noreferrer">
          <IconButton color="primary">
            <ArrowRightIcon/>
          </IconButton>
        </a>
        <ListItemText secondary={instrument.name}/>
      </>
  );
}

export default PreviousVersionLink;
